<template lang="html">
  <section :id="id" class="select-option">
    <span v-if="label" :for="selectId" class="main-label">
      {{ label }}
    </span>
    <div class="slds-form-element">
      <label v-if="topLabel" :for="selectId" class="slds-form-element__label">
        {{ topLabel }}
      </label>
      <div class="slds-form-element__control">
        <div class="slds-select_container">
          <select
            class="slds-select"
            :id="selectId"
            v-model="model"
            @change.stop="onOptionChange"
          >
            <option
              v-for="(option, index) in formattedOptions"
              :key="index"
              :value="option"
            >
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
  import { v4 as uuidv4 } from "uuid";
  import i18n from "@/plugins/i18n";

  export default {
    name: "select-option-rich",
    props: {
      id: String,
      topLabel: String,
      label: String,
      selected: String,
      options: {
        type: Array,
        default: function() {
          return []
        }
      }
    },
    data() {
      return {
        model: {}
      }
    },
    watch: {
      selected: function() {
        this.updateModel();
      }
    },
    computed: {
      selectId() {
        return `select-option-rich-${uuidv4()}`;
      },
      formattedOptions() {
        return this.options.map(o => {
          if (o.toLowerCase() === "all") {
            return {
              key: o,
              label: i18n.t("all")
            };
          }
          return {
            key: o,
            label: o
          };
        });
      }
    },
    mounted() {
      this.updateModel();
    },
    methods: {
      updateModel() {
        if (this.selected.toLowerCase() === "all") {
          this.model = {
            key: this.selected,
            label: i18n.t("all")
          }
        } else {
          this.model = {
            key: this.selected,
            label: this.selected
          }
        }
      },
      onOptionChange() {
        this.$emit("on-select-option-change", this.model.key, this.id);
      },
    }
  };
</script>

<style scoped lang="scss">
  .select-option {
    display: flex;
    align-items: center;
    .main-label {
      white-space: nowrap;
      margin-right: 0.5rem;
    }
    .slds-form-element {
      flex-grow: 1;
    }
  }
</style>
